import TechnicalDesignModal from './TechnicalDesignModal.component';

export default TechnicalDesignModal;
